import { useCallback, useContext } from "react"
import { useAppDispatch } from "hooks/redux"
import { closeDockPane, setReportToOpen } from "../store/agent-chat-slice"
import { KellyLinkContext, useKellyLinkNavigate } from "../kelly-link-types"

export function useOpenReport() {
  const dispatch = useAppDispatch()
  const navigate = useKellyLinkNavigate()
  const { link } = useContext(KellyLinkContext)
  return useCallback((deliverableId: string) => {
    dispatch(closeDockPane())
    if (!navigate("reports", deliverableId, { replace: link?.type === "reports" })) dispatch(setReportToOpen(deliverableId))
  }, [dispatch, navigate, link])
}
